export enum AzureDataKeys {
	// Analytics, READ/LIST/DELETE SAS
	storage_account = 'storage_account',
	bbox_sas = 'bbox_sas',
	order_ci_sas = 'order_ci_sas',
	machine_backup_sas = 'machine_backup_sas',

	// AGILOX machine, WRITE SAS
	bbox_sas_write = 'bbox_sas_write',
	order_ci_sas_write = 'order_ci_sas_write',
	machine_backup_sas_write = 'machine_backup_sas_write',

	// AGILOX machine archive, WRITE SAS,
	bbox_archive_sas_write = 'bbox_archive_sas_write',
	order_ci_archive_sas_write = 'order_ci_archive_sas_write',
	machine_backup_archive_sas_write = 'machine_backup_archive_sas_write',

	iot_hub = 'iot_hub',
	iothub_password = 'iothub_password',
	iothub_username = 'iothub_username',
}
